module.exports = __webpack_public_path__ + "img/waistband length.1bcd66d7.png";